export default __webpack_public_path__ + "static/media/GateEntry.26f98482.svg";